module.exports = __webpack_public_path__ + "static/img/game_img.6ef8042.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/game_img.png
// module id = l6JG
// module chunks = 0